export default import.meta.ROLLDOWN_FILE_URL_jRimste4ipH0DaZTvduH8w